import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const SummaryBody = ({ children, className, ...rest }) => {
  return (
    <Grid.Row className={`${className} SummaryBody`} {...rest}>
      <Grid.Column>{children}</Grid.Column>
    </Grid.Row>
  )
}

export default SummaryBody
